module.exports = __webpack_public_path__ + "img/background1.4a0d7267.webp";